import { render } from "./CrudFilaVeiculo.vue?vue&type=template&id=508a86c5"
import script from "./CrudFilaVeiculo.vue?vue&type=script&lang=ts"
export * from "./CrudFilaVeiculo.vue?vue&type=script&lang=ts"
script.render = render

export default script